import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ApiService } from '../../../../_core/_services/api.service';
import { PortalFiles } from 'src/app/_share/_models/portal/interfaces';

@Injectable({
  providedIn: 'root'
})
export class PortalManagementFilesService {
  constructor(private api: ApiService) {}

  getPortalFiles(portal_customer_id: number): Observable<PortalFiles[]> {
    return this.api
      .getAPI(`portal/management/customers/files/${portal_customer_id}`)
      .pipe(map((res: { body: { data: PortalFiles[] } }) => res.body.data));
  }

  downloadPortalCustomerFile(unique_file_reference: string, extension: string): void {
    this.api
      .getFileAPI('portal/management/customers/download-file', unique_file_reference)
      .subscribe((response: { headers: Headers; body: Blob }) => {
        const contentDispositionHeader = response.headers.get('Content-Disposition');
        let fileName = `${unique_file_reference}.${extension}`;
        if (contentDispositionHeader) {
          const matches = contentDispositionHeader.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
          if (matches && matches.length > 1) {
            fileName = matches[1].replace(/['"]/g, '');
          }
        }
        const a = document.createElement('a');
        a.download = fileName;
        a.href = window.URL.createObjectURL(response.body);
        a.click();
      });
  }

  uploadPortalCustomerFile(
    portalUserFile: FormData,
    portal_end_customer_id: number,
    document_type: string
  ): Observable<unknown> {
    return this.api.postAPI(
      `portal/management/customers/upload-file?portal_end_customer_id=${portal_end_customer_id}&document_type=${document_type}`,
      portalUserFile
    );
  }
}
